import { isArray, mergeWith } from 'lodash';

export const mergeFn = (a, b) => isArray(a) ? a.concat(b) : undefined;

export const mergeObjects = (obj1, obj2) => {
  return mergeWith(obj1, obj2, mergeFn);
};
